import api from 'service/index';

import { SELF_SERVICE } from 'constants/url';

import { NotificationType } from 'modules/notifications/types/Notification';

import { addNotification } from 'modules/notifications/actions';
import { DEFAULT_UPDATE_ERROR } from 'constants/messages';

const restrictedAccessApi = api.injectEndpoints({
  endpoints: (build) => ({
    open: build.query({
      query: ({ selfServiceId }) => ({
        method: 'POST',
        url: `${SELF_SERVICE}/${selfServiceId}/kiosk/restrictedAccess/relay/open`,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch {
          dispatch(
            addNotification({
              title: {
                id: 'restrictedAccess.openingError',
                defaultMessage: 'An error occurred while opening the gate',
              },
              ...DEFAULT_UPDATE_ERROR,
              type: NotificationType.ERROR,
            }),
          );
        }
      },
    }),
  }),
});

export default restrictedAccessApi;
